// extracted by mini-css-extract-plugin
export default {"navbarHeight":"60px","results":"styles_results__0uT+c","active":"styles_active__CpNon"};